export interface NavItem {
  to: string;
  label: string;
  /** Nama ikon WDS (hanya dipakai item tingkat atas). */
  icon?: string;
  /** Item hanya tampil bila pengguna punya izin ini. */
  perm?: string;
  /** Item hanya tampil bila fitur ini aktif untuk tenant (paket / Super Admin). */
  feature?: string;
}
export interface NavGroup {
  label: string;
  icon?: string;
  items: NavItem[];
}
export type NavEntry = NavItem | NavGroup;
export const isGroup = (e: NavEntry): e is NavGroup => 'items' in e;
